import {
  Button,
  Grid,
  Icon,
  ListItem,
  Text,
  UnorderedList,
  VStack,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import useAuth from '../../../../app/src/features/authentication/hooks/useAuth';
import {
  GENERAL_PAGE_PY,
  GENERAL_PAGE_PX,
} from '../../../../common/src/components/GeneralPageLayout';
import AdvisoryAppShell from '../../../../flows/src/components/ui/advisory-flow/components/app-shell/AdvisoryAppShell';
import FinalizePartyHatIllustration from '../../features/finalize/FinalizePartyHatIllustration';
import FinalizeTextBlock from '../../features/finalize/FinalizeTextBlock';

interface Props {
  title: string;
  description: string;
  accountURL?: string;
}

const FinalizePageContent: React.FC<Props> = ({
  title,
  description,
  accountURL,
}) => {
  const { t } = useTranslation();
  const { distribution } = useAuth();

  return (
    <AdvisoryAppShell>
      <Grid
        gridTemplateColumns="auto 1fr"
        maxW="6xl"
        margin="0 auto"
        py={GENERAL_PAGE_PY}
        px={GENERAL_PAGE_PX}
        gap="6"
        h="100%"
        overflowY="auto"
      >
        <FinalizePartyHatIllustration />
        <VStack spacing="14" align="flex-start" mt="10">
          <FinalizeTextBlock title={title}>
            <Text
              dangerouslySetInnerHTML={{
                __html: description,
              }}
            />
          </FinalizeTextBlock>
          {accountURL && (
            <>
              <FinalizeTextBlock
                title={t('SALES-CONVERSATION_PIA_FINALIZE_TITLE_2')}
              >
                <Trans
                  i18nKey={t('SALES-CONVERSATION_PIA_FINALIZE_DESCRIPTION_2', {
                    distribution: distribution.name,
                  })}
                  components={{
                    ul: <UnorderedList pl="2" spacing="2" mt="2" />,
                    li: <ListItem />,
                  }}
                />
              </FinalizeTextBlock>

              <Button
                as="a"
                borderRadius="full"
                size="lg"
                leftIcon={<Icon name="GeneralOthersAvatar" />}
                href={accountURL}
                target="_blank"
              >
                {t('SALES-CONVERSATION_PIA_FINALIZE_TO-MY-ACCOUNT')}
              </Button>
            </>
          )}
        </VStack>
      </Grid>
    </AdvisoryAppShell>
  );
};

export default FinalizePageContent;
